import { ReactElement } from "react";

export const ErrorMessage = ({
  message,
}: {
  message: string;
}): ReactElement => (
  <div className="flex min-h-[200px] flex-col items-center justify-center gap-4">
    <div className="rounded-full bg-red-100 p-3">
      <svg
        className="h-6 w-6 text-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          d="M6 18L18 6M6 6l12 12"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
    </div>

    <p className="text-sm text-zinc-600">Failed to load: {message}</p>
  </div>
);
